import { forecastersService } from '../../../services/api/forecasters.endpoint';
import store from '../../../store';
import { setForecastersList, setPastMonthForcast, setForecastGraphAndTableData, setForcastLastYearData, setForecastLastTwelveMonthsData, setWebsiteTargetList } from '../../../features/forecastersSlice';
import { setAllUsers, setDisplayErrorSnackBar } from '../../../features/userSlice';

async function getForecastersList(selectedSharedUid: string, oauthTokenHeader: string, year: string, dispatch: any) {
  try {
    const response = await forecastersService.getForecastersList(oauthTokenHeader, selectedSharedUid, year);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get forecasters list");
    } else {
      dispatch(setForecastersList(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || "Unknown error occurred", type: "error" }));
  }
};

async function getAllWebsiteTarget(oauthTokenHeader: string,website_shared_uid:any,dispatch:any) {
    try {
        const response = await forecastersService.getAllWebsiteTarget(oauthTokenHeader,website_shared_uid);
        if (!response || !response.status || response.status !== 200) {
            // throw new Error('Failed to get page content');
        }
        else {
            dispatch(setWebsiteTargetList(response?.data?.data)); // Set the fetched data
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function getPastMonthForcast(oauthTokenHeader: string, QUERY_ID: string, selectedSharedUid: string, date: string, forecast_content_shared_uid: string, dispatch: any) {
  try {
    const response = await forecastersService.getPastMonthForcast(oauthTokenHeader, QUERY_ID, selectedSharedUid, date, forecast_content_shared_uid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get past month forecast");
    } else {
      dispatch(setPastMonthForcast(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || "Unknown error occurred", type: "error" }));
  }
}

async function getDeviationData(oauthTokenHeader: string, QUERY_ID: string, selectedSharedUid: string, date: string, forecast_content_shared_uid: string) {
  try {
    const response = await forecastersService.getPastMonthForcast(oauthTokenHeader, QUERY_ID, selectedSharedUid, date, forecast_content_shared_uid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get past month forecast");
    } else {
      return response?.data?.data;
    }
  } catch (error: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || "Unknown error occurred", type: "error" }));
  }
}

async function getForecasterGraphAndTableData(oauthTokenHeader: string, QUERY_ID: string, date: string, selectedSharedUid: string, metric: string, dispatch: any) {
  try {
    const response = await forecastersService.getForecasterGraphAndTableData(oauthTokenHeader, QUERY_ID, selectedSharedUid, date, metric);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get forecaster graph and table data");
    } else {
      dispatch(setForecastGraphAndTableData(response?.data?.data));
    }
  } catch (error: any) {
  console.error("getForecasterLastYearData error:", error);

  // Extract readable error text
  let errorMessage = "Unknown error occurred";

  if (typeof error === "string") {
    errorMessage = error;
  } else if (error?.response?.data?.reason) {
    errorMessage = error.response.data.reason;
  } else if (error?.message) {
    errorMessage = error.message;
  } else if (error?.reason) {
    errorMessage = error.reason;
  } else {
    // Fallback - stringify the object safely
    try {
      errorMessage = JSON.stringify(error);
    } catch {
      errorMessage = String(error);
    }
  }

  // Dispatch safe, string-only message
  store.dispatch(setDisplayErrorSnackBar({ message: errorMessage, type: "error" }));
}
}

async function getForecasterLastYearData(oauthTokenHeader: string, QUERY_ID: string, date: string, selectedSharedUid: string, metric: string, dispatch: any) {
  try {
    const response = await forecastersService.getForecasterLastYearData(oauthTokenHeader, QUERY_ID, selectedSharedUid, date, metric);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get forecaster last year data");
    } else {
      dispatch(setForcastLastYearData(response?.data?.data));
    }
  } catch (error: any) {
  console.error("getForecasterLastYearData error:", error);

  // Extract readable error text
  let errorMessage = "Unknown error occurred";

  if (typeof error === "string") {
    errorMessage = error;
  } else if (error?.response?.data?.reason) {
    errorMessage = error.response.data.reason;
  } else if (error?.message) {
    errorMessage = error.message;
  } else if (error?.reason) {
    errorMessage = error.reason;
  } else {
    // Fallback - stringify the object safely
    try {
      errorMessage = JSON.stringify(error);
    } catch {
      errorMessage = String(error);
    }
  }

  // Dispatch safe, string-only message
  store.dispatch(setDisplayErrorSnackBar({ message: errorMessage, type: "error" }));
}
}

async function getForecasterLastTwelveMonthsData(oauthTokenHeader: string, QUERY_ID: string, selectedSharedUid: string, dispatch: any) {
  const response = await forecastersService.getForecasterLastTwelveMonthsData(oauthTokenHeader, QUERY_ID, selectedSharedUid);
  try {
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get forecaster last twelve months data");
    } else {
      dispatch(setForecastLastTwelveMonthsData(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || "Unknown error occurred", type: "error" }));
  }
}

async function createNewForecast(oauthTokenHeader: string, data: any, selectedSharedUid: string) {
  // store.dispatch(setIsLoading(true));
  try {
    const response = await forecastersService.createNewForecast(oauthTokenHeader, data, selectedSharedUid);
    if (!response || !response.status || response.status !== 201) {
      store.dispatch(setDisplayErrorSnackBar({ message: "Failed to create new forecast", type: "error" }));
      return null;
    }
    return response;
  } catch (error: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || "Unknown error occurred", type: "error" }));
    return null;
  } finally {
    // store.dispatch(setIsLoading(false));
  }
}

//Get all users for forecast
async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await forecastersService.getAllUsers(
      oauthTokenHeader
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

//Get comments for foreCaster
async function getCommentsForForecaster(
  oauthTokenHeader: any,
  object_shared_uid: any,
  setComments: any
) {
  try {
    const response = await forecastersService.getComments(
      oauthTokenHeader,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      setComments([]);
      throw new Error("Failed to get comments for specific task");
    } else {
      setComments(response?.data?.data);
    }
  } catch (e: any) {
    console.error(e);
  }
}

//Post comment for foreCaster
async function postCommentForForecaster(
  oauthTokenHeader: any,
  data: any,
  objectSharedUid: any
) {
  try {
    const response = await forecastersService.postComment(
      oauthTokenHeader,
      data,
      objectSharedUid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to add new comment");
    } else {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Comment has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

//Edit comment for foreCaster
async function putCommentsForForeCaster(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any
) {
  try {
    const response = await forecastersService.putComments(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to edit comments");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

//Delete comment for foreCaster
async function deleteCommentForForeCaster(
  oauthTokenHeader: any,
  object_shared_uid: any,
  comment_shared_uid: any
) {
  try {
    const response = await forecastersService.deleteComment(
      oauthTokenHeader,
      object_shared_uid,
      comment_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to delete comments");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

//Add files for foreCaster
async function uploadFileForForeCaster(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any
) {
  try {
    const response = await forecastersService.uploadFile(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload files");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

//Get files for foreCaster
async function getFilesForForeCaster(
  oauthTokenHeader: any,
  object_shared_uid: any,
  setFiles: any
) {
  try {
    const response = await forecastersService.getFiles(
      oauthTokenHeader,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      setFiles([]);
      throw new Error("Failed to get files");
    } else {
      setFiles(response?.data?.data);
    }
  } catch (e: any) {
    console.error(e);
  }
}

//Delete file for foreCaster
async function deleteFileForForeCaster(
  oauthTokenHeader: any,
  file_shared_uid: any
) {
  try {
    const response = await forecastersService.deleteFile(
      oauthTokenHeader,
      file_shared_uid
    );
    if (!response || !response.status) {
      throw new Error("Failed to delete file");
    } else if (response.status === 204) {
      //response?.data as returns null when file is deleted successfully
      // This is a success case, so we can return a custom success message 
     // let sucessMsg = { reason: "Success." }; // Set a success message
      return response?.data; 
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}


export const forecastersEndPointLogic = { getForecastersList, getAllWebsiteTarget, getPastMonthForcast, getDeviationData, getForecasterGraphAndTableData, getForecasterLastYearData, getForecasterLastTwelveMonthsData, createNewForecast, getAllUserList, getCommentsForForecaster, postCommentForForecaster, putCommentsForForeCaster, deleteCommentForForeCaster, uploadFileForForeCaster, getFilesForForeCaster, deleteFileForForeCaster };
